// Element.closest pollyfil
import closest from 'element-closest'; // eslint-disable-line no-unused-vars

/**
 * Find the parent level from a seat element
 *
 * Tries to find closest layer starting with 'level'
 * Failing that assumes the following structure:
 * level -> row -> seat-els
 */
export default function(el) {
  const closestMatch = el.closest("[class^='syos-level']");
  if (closestMatch) {
    return closestMatch;
  } else {
    return el.parentNode.parentNode;
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/seatmaps/findParentLevel.js